import { render, staticRenderFns } from "./EditItemTypeModal.vue?vue&type=template&id=4c79a914"
import script from "./EditItemTypeModal.vue?vue&type=script&lang=js"
export * from "./EditItemTypeModal.vue?vue&type=script&lang=js"
import style0 from "./EditItemTypeModal.vue?vue&type=style&index=0&id=4c79a914&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports